import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  description: {
    id: 'studio.vMfCdf',
    defaultMessage: 'The open source low-code app building platform',
  },
});
